import { toastr } from 'react-redux-toastr';
import {
    pendingTask, // The action key for modifying loading state
    begin, // The action value if a "long" running task begun
    end, // The action value if a "long" running task ended
} from 'react-redux-spinner';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import { UPDATE_GLOBAL_SETUP } from './globalSetup.actions';
import i18n from '../../../services/i18n';
import {
    getGlobalSetup,
    updateGlobalSetupSettings,
} from '../../services/api-endpoints';

const tFixedCommon = i18n.getFixedT(null, 'shiftBidding', 'admin.common.action');
const tFixed = i18n.getFixedT(null, 'globalSetup');

/** @type { () => (dispatch: import('redux').Dispatch) => void} */
export const fetchGlobalSetup = () => async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });

    try {
        const { data: allGlobalResponse } = await getGlobalSetup();

        dispatch({
            type: UPDATE_GLOBAL_SETUP,
            payload: {
                ...allGlobalResponse,
                isGlobalSetupDataLoaded: true,
                reset: allGlobalResponse,
            },
        });
    } catch (error) {
        // @ts-ignore
        toastr.error('Loading app data', error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};

// TODO - Check with QA in the future how this should be in terms of UI (only button) or individual submit buttons
/** @type { (data: GlobalSetup.GlobalSetup) => (dispatch: import('redux').Dispatch) => void} */
export const updateGlobalSetup = (data) => async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });
    try {
        const { status, data: updatedData } = await updateGlobalSetupSettings(data);
        if (status === 200) {
            dispatch({
                type: UPDATE_GLOBAL_SETUP,
                payload: {
                    ...updatedData,
                    reset: updatedData,
                },
            });
            toastr.success(tFixed('edition'), tFixed('editionSuccess'));
        } else {
            const errorTitle = `${tFixedCommon('saving')} ${tFixedCommon('configSet')}`;
            const message = `${tFixedCommon('saving')} ${tFixedCommon('failed')}`;
            toastr.error(errorTitle, message);
        }
    } catch (error) {
        // @ts-ignore
        (error?.response?.data?.Message || '')
            .split(/<br\s*\/?>|\r?\n/)
            .map((s) => s.trim())
            .filter(Boolean)
            .forEach((msg) => toastr.error('Loading app data', msg));
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
